// context/BookingContext.js
import { createContext, useState, useContext } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [procedure, setProcedure] = useState(null);
  const [proceduresAll, setProceduresAll] = useState([]);
  const [examsSelected, setExamsSelected] = useState([]);
  const [exams, setExams] = useState([]);
  const [partners, setPartners] = useState([]);
  const [partnersAll, setPartnersAll] = useState([]);
  const [partner, setPartner] = useState(null);
  const [selectedExamsData, setSelectedExamsData] = useState([]);

  const [bookingDetails, setBookingDetails] = useState({
    affiliate_company_id: null,
    clinic_id: null,
    status: null,
    comment: null,
    scheduling_date: null,
    procedures: [],
  });

  return (
    <BookingContext.Provider
      value={{
        procedure,
        setProcedure,
        proceduresAll,
        setProceduresAll,
        exams,
        setExams,
        examsSelected,
        setExamsSelected,
        partners,
        setPartners,
        partnersAll,
        setPartnersAll,
        partner,
        setPartner,
        bookingDetails,
        setBookingDetails,
        selectedExamsData,
        setSelectedExamsData,
      }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
